import { bool, number } from 'prop-types';
import React from 'react';
import { GoPencil } from 'react-icons/go';

import EntityLabel from '../../../generic/EntityLabel';

function InvoiceModalLink({ id, isEditing }) {
  return (
    <>
      Invoice
      <EntityLabel id={id} resourceType="invoice" />
      {isEditing && (
        <span className="text-muted font-weight-light ml-2 small va-tb">
          <GoPencil />
        </span>
      )}
    </>
  );
}

InvoiceModalLink.propTypes = { id: number.isRequired, isEditing: bool };
InvoiceModalLink.defaultProps = { isEditing: true };

export default InvoiceModalLink;
